import { ReduxStore } from 'store/types';

function importSpreadsheetInBackground(state: ReduxStore): boolean {
  return state.product.importSpreadsheet.generatingInBackground;
}

export default importSpreadsheetInBackground;
